"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEvents = fetchEvents;
const client_js_1 = require("../client.js");
const maps_js_1 = require("../../common/maps.js");
const constants_js_1 = require("../../common/constants.js");
async function fetchEvents(params) {
    const allEvents = [];
    let hasNextPage = true;
    let startCursor = null;
    const order = params.order ? params.order : "descending";
    if (params.eventTypes.length > 1) {
        console.warn("Multiple eventTypes not supported right now, pass only one element in the array.");
    }
    if (params.eventTypes.length < 1) {
        hasNextPage = false;
    }
    const now = Date.now();
    const twentyFourHoursAgo = now - 24 * 60 * 60 * 1000; // timestamp for 24 hours ago
    const startTime = params.startTime ? params.startTime : twentyFourHoursAgo;
    const endTime = params.endTime ? params.endTime : now;
    if (startTime >= endTime) {
        throw new Error("startTime must be less than endTime");
    }
    const suiClient = (0, client_js_1.getSuiClient)();
    //const prevTS = 0;
    while (hasNextPage) {
        const result = await suiClient.queryEvents({
            cursor: startCursor,
            order: order,
            query: {
                MoveEventType: params.eventTypes[0],
            },
        });
        const se = result.data;
        for (let i = 0; i < se.length; i++) {
            const suiEvent = se[i];
            if (Number(suiEvent.timestampMs) > endTime) {
                continue;
            }
            if (Number(suiEvent.timestampMs) < startTime) {
                hasNextPage = false; // Stop further pagination
                break; // Exit the loop
            }
            const suiEventJson = suiEvent.parsedJson;
            let eventNode;
            if (isAutoCompoundingEvent(suiEvent.type) &&
                "compound_amount_a" in suiEventJson &&
                "compound_amount_b" in suiEventJson &&
                "cur_debt_a" in suiEventJson) {
                // Handling LyfAutoCompoundingEvent
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    compound_amount_a: BigInt(suiEventJson.compound_amount_a.toString()),
                    compound_amount_b: BigInt(suiEventJson.compound_amount_b.toString()),
                    current_liquidity: BigInt(suiEventJson.current_liquidity.toString()),
                    fee_collected_a: BigInt(suiEventJson.fee_collected_a.toString()),
                    fee_collected_b: BigInt(suiEventJson.fee_collected_b.toString()),
                    free_balance_a: BigInt(suiEventJson.free_balance_a.toString()),
                    free_balance_b: BigInt(suiEventJson.free_balance_b.toString()),
                    investor_id: suiEventJson.investor_id,
                    total_amount_a: BigInt(suiEventJson.total_amount_a.toString()),
                    total_amount_b: BigInt(suiEventJson.total_amount_b.toString()),
                    cur_debt_a: BigInt(suiEventJson.cur_debt_a.toString()),
                    cur_debt_b: BigInt(suiEventJson.cur_debt_b.toString()),
                    accrued_interest_a: BigInt(suiEventJson.accrued_interest_a.toString()),
                    accrued_interest_b: BigInt(suiEventJson.accrued_interest_b.toString()),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isAutoCompoundingEvent(suiEvent.type) &&
                "compound_amount_a" in suiEventJson &&
                "compound_amount_b" in suiEventJson) {
                // Handling CetusAutoCompoundingEvent
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    compound_amount_a: BigInt(suiEventJson.compound_amount_a.toString()),
                    compound_amount_b: BigInt(suiEventJson.compound_amount_b.toString()),
                    current_liquidity: BigInt(suiEventJson.current_liquidity.toString()),
                    fee_collected_a: BigInt(suiEventJson.fee_collected_a.toString()),
                    fee_collected_b: BigInt(suiEventJson.fee_collected_b.toString()),
                    free_balance_a: BigInt(suiEventJson.free_balance_a.toString()),
                    free_balance_b: BigInt(suiEventJson.free_balance_b.toString()),
                    investor_id: suiEventJson.investor_id,
                    total_amount_a: BigInt(suiEventJson.total_amount_a.toString()),
                    total_amount_b: BigInt(suiEventJson.total_amount_b.toString()),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
                // if (
                //   eventNode.investor_id ===
                //   "0xd060e81548aee885bd3d37ae0caec181185be792bf45412e0d0acccd1e0174e6"
                // ) {
                //   console.log(
                //     eventNode.timestamp,
                //     (prevTS - eventNode.timestamp) / (1000 * 60),
                //   );
                //   prevTS = eventNode.timestamp;
                // }
            }
            else if (isAutoCompoundingEvent(suiEvent.type) &&
                "compound_amount" in suiEventJson) {
                // Handling NaviAutoCompoundingEvent (lending and looping)
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    compound_amount: BigInt(suiEventJson.compound_amount.toString()),
                    fee_collected: BigInt(suiEventJson.fee_collected.toString()),
                    investor_id: suiEventJson.investor_id,
                    location: suiEventJson.location,
                    total_amount: BigInt(suiEventJson.total_amount.toString()),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
                if ("cur_total_debt" in suiEventJson &&
                    "accrued_interest" in suiEventJson) {
                    const loopEvent = {
                        ...eventNode,
                        cur_total_debt: BigInt(suiEventJson.cur_total_debt.toString()),
                        accrued_interest: BigInt(suiEventJson.accrued_interest.toString()),
                    };
                    eventNode = loopEvent;
                }
            }
            else if (isAutoCompoundingEvent(suiEvent.type) &&
                "amount" in suiEventJson &&
                !("total_amount_a" in suiEventJson)) {
                // alpha autocompounding event
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    amount: suiEventJson.amount,
                    investor_id: constants_js_1.conf[constants_js_1.CONF_ENV].ALPHA_POOL,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isAutoCompoundingEvent(suiEvent.type) &&
                "amount" in suiEventJson &&
                "total_amount_a" in suiEventJson) {
                // new autobalance autocompounding event (reward events)
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    amount: BigInt(suiEventJson.amount.toString()),
                    coin_type: suiEventJson.coin_type,
                    fee_collected: BigInt(suiEventJson.fee_collected.toString()),
                    investor_id: suiEventJson.investor_id,
                    total_amount_a: BigInt(suiEventJson.total_amount_a.toString()),
                    total_amount_b: BigInt(suiEventJson.total_amount_b.toString()),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
                // if (
                //   eventNode.investor_id ===
                //   "0xd060e81548aee885bd3d37ae0caec181185be792bf45412e0d0acccd1e0174e6"
                // ) {
                //   console.log(
                //     eventNode.timestamp,
                //     (prevTS - eventNode.timestamp) / (1000 * 60),
                //   );
                //   prevTS = eventNode.timestamp;
                // }
            }
            else if (isAutoCompoundingEvent(suiEvent.type) &&
                "blue_reward_amount" in suiEventJson) {
                // old autobalance autocompound event
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    blue_reward_amount: BigInt(suiEventJson.blue_reward_amount.toString()),
                    current_liquidity: BigInt(suiEventJson.current_liquidity.toString()),
                    fee_collected: BigInt(suiEventJson.fee_collected.toString()),
                    free_balance_a: BigInt(suiEventJson.free_balance_a.toString()),
                    free_balance_b: BigInt(suiEventJson.free_balance_b.toString()),
                    investor_id: suiEventJson.investor_id,
                    total_amount_a: BigInt(suiEventJson.total_amount_a.toString()),
                    total_amount_b: BigInt(suiEventJson.total_amount_b.toString()),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isRebalanceEvent(suiEvent.type) &&
                "lower_tick_after" in suiEventJson) {
                // Handling RebalanceEvent
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    investor_id: suiEventJson.investor_id.toString(),
                    lower_tick_after: suiEventJson.lower_tick_after.toString(),
                    upper_tick_after: suiEventJson.upper_tick_after.toString(),
                    sqrt_price_after: suiEventJson.sqrt_price_after.toString(),
                    amount_a_before: suiEventJson.amount_a_before.toString(),
                    amount_b_before: suiEventJson.amount_b_before.toString(),
                    amount_a_after: suiEventJson.amount_a_after.toString(),
                    amount_b_after: suiEventJson.amount_b_after.toString(),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isLiquidityChangeEvent(suiEvent.type) &&
                "amount_a" in suiEventJson) {
                // Handling CetusLiquidityChangeEvent
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    amount_a: suiEventJson.amount_a,
                    amount_b: suiEventJson.amount_b,
                    event_type: suiEventJson.event_type,
                    fee_collected_a: suiEventJson.fee_collected_a,
                    fee_collected_b: suiEventJson.fee_collected_b,
                    pool_id: suiEventJson.pool_id,
                    tokens_invested: suiEventJson.tokens_invested,
                    total_amount_a: suiEventJson.total_amount_a,
                    total_amount_b: suiEventJson.total_amount_b,
                    user_total_x_token_balance: suiEventJson.user_total_x_token_balance,
                    x_token_supply: suiEventJson.x_token_supply,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isLiquidityChangeEvent(suiEvent.type) &&
                "amount" in suiEventJson &&
                !("investor_id" in suiEventJson) &&
                !("amount_withdrawn_from_locked" in suiEventJson) &&
                !("xtokenSupply" in suiEventJson)) {
                // Handling NaviLiquidityChangeEvent and AlphaLiquidityChangeEvent
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    amount: suiEventJson.amount,
                    event_type: suiEventJson.event_type,
                    fee_collected: suiEventJson.fee_collected,
                    pool_id: suiEventJson.pool_id,
                    tokens_invested: suiEventJson.tokens_invested,
                    user_total_x_token_balance: suiEventJson.user_total_x_token_balance,
                    x_token_supply: suiEventJson.x_token_supply,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isWithdrawV2Event(suiEvent.type) &&
                "amount_withdrawn_from_locked" in suiEventJson) {
                // Handling Alpha WithdrawV2 Events
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    amount: suiEventJson.amount,
                    amount_withdrawn_from_locked: suiEventJson.amount_withdrawn_from_locked,
                    amount_withdrawn_from_unlocked: suiEventJson.amount_withdrawn_from_unlocked,
                    fee_collected: suiEventJson.fee_collected,
                    instant_withdraw_fee_collected: suiEventJson.instant_withdraw_fee_collected,
                    pool_id: suiEventJson.pool_id,
                    tokens_invested: suiEventJson.tokens_invested,
                    user_total_x_token_balance: suiEventJson.user_total_x_token_balance,
                    x_token_supply: suiEventJson.x_token_supply,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isAfterTransactionEvent(suiEvent.type) &&
                "tokensInvested" in suiEventJson &&
                !("liquidity" in suiEventJson) &&
                !("amount" in suiEventJson)) {
                //handling alpha after transaction event
                if (suiEvent.id.eventSeq === "0")
                    continue;
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    poolName: "ALPHA",
                    id: {
                        eventSeq: Number(suiEvent.id.eventSeq),
                        txDigest: suiEvent.id.txDigest,
                    },
                    tokensInvested: suiEventJson.tokensInvested,
                    xTokenSupply: suiEventJson.xTokenSupply,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isAfterTransactionEvent(suiEvent.type) &&
                "tokensInvested" in suiEventJson &&
                "liquidity" in suiEventJson) {
                //handling  cetus after transaction event
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    poolName: undefined,
                    id: {
                        eventSeq: Number(suiEvent.id.eventSeq),
                        txDigest: suiEvent.id.txDigest,
                    },
                    tokensInvested: suiEventJson.tokensInvested,
                    xtokenSupply: suiEventJson.xtokenSupply,
                    liquidity: suiEventJson.liquidity,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (isAfterTransactionEvent(suiEvent.type) &&
                "amount" in suiEventJson &&
                "tokensInvested" in suiEventJson) {
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    poolName: undefined,
                    id: {
                        eventSeq: Number(suiEvent.id.eventSeq),
                        txDigest: suiEvent.id.txDigest,
                    },
                    tokensInvested: suiEventJson.tokensInvested,
                    xtokenSupply: suiEventJson.xtokenSupply,
                    amount: suiEventJson.amount,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if ("ratio" in suiEventJson) {
                // Check Ratio - looping pools
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    ratio: suiEventJson.ratio,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else if (suiEvent.type === constants_js_1.conf[constants_js_1.CONF_ENV].VOTE_CAST_EVENT_TYPE &&
                "proposal_id" in suiEventJson &&
                "voter" in suiEventJson &&
                "previous_vote_choice" in suiEventJson &&
                "vote_choice" in suiEventJson) {
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    proposal_id: suiEventJson.proposal_id,
                    voter: suiEventJson.voter,
                    previous_vote_choice: suiEventJson.previous_vote_choice,
                    vote_choice: suiEventJson.vote_choice,
                    sender: suiEvent.sender,
                };
            }
            else if (suiEvent.type === constants_js_1.conf[constants_js_1.CONF_ENV].AIRDROP_CLAIM_EVENT_TYPE &&
                "airdrop_amount" in suiEventJson &&
                "relock_amount" in suiEventJson) {
                // Handling AirdropClaimEvent
                eventNode = {
                    type: suiEvent.type,
                    timestamp: Number(suiEvent.timestampMs),
                    airdrop_amount: suiEventJson.airdrop_amount,
                    relock_amount: suiEventJson.relock_amount,
                    txDigest: suiEvent.id.txDigest,
                    eventSeq: Number(suiEvent.id.eventSeq),
                    transactionModule: suiEvent.transactionModule,
                    sender: suiEvent.sender,
                };
            }
            else {
                console.error("Unknown event type \n event: ", suiEvent, "json: ", suiEventJson);
                // throw new Error("Unknown event type");
                continue;
            }
            allEvents.push(eventNode);
        }
        // If we set hasPreviousPage to false, exit the outer loop as well
        if (!hasNextPage) {
            break;
        }
        hasNextPage = result.hasNextPage;
        startCursor = result.nextCursor;
    }
    return allEvents;
}
const isAutoCompoundingEvent = (eventType) => {
    let eventTypes = Object.values(maps_js_1.poolInfo).map((info) => {
        return info.autoCompoundingEventType;
    });
    eventTypes = eventTypes.concat(Object.values(maps_js_1.poolInfo)
        .map((info) => {
        return info.autobalanceOldAutoCompoundingEventType;
    })
        .filter((type) => type != undefined));
    return eventTypes.includes(eventType);
};
const isRebalanceEvent = (eventType) => {
    const eventTypes = Object.values(maps_js_1.poolInfo)
        .filter((info) => {
        return info.rebalanceEventType ? true : false;
    })
        .map((info) => {
        return info.rebalanceEventType;
    });
    return eventTypes.includes(eventType);
};
const isLiquidityChangeEvent = (eventType) => {
    const eventTypes = Object.values(maps_js_1.poolInfo).map((info) => {
        return info.liquidityChangeEventType;
    });
    return eventTypes.includes(eventType);
};
const isWithdrawV2Event = (eventType) => {
    const eventTypes = Object.values(maps_js_1.poolInfo)
        .map((info) => {
        return info.withdrawV2EventType;
    })
        .filter((type) => type !== undefined);
    return eventTypes.includes(eventType);
};
const isAfterTransactionEvent = (eventType) => {
    const eventTypes = Object.values(maps_js_1.poolInfo)
        .map((info) => {
        return info.afterTransactionEventType;
    })
        .filter((type) => type !== undefined);
    return eventTypes.includes(eventType);
};
//# sourceMappingURL=fetchEvents.js.map